module.exports = __webpack_public_path__ + "img/pizza-garden.951c8a82.webp";